export const CANCELLATION_STAGE = {
	CANCEL_SERVICE: 'CANCEL_SERVICE',
	FAST_CANCELLATION: 'FAST_CANCELLATION',
	SUBMITTED_REQUEST: 'SUBMITTED_REQUEST',
	REQUEST_ASSISTANCE: 'REQUEST_ASSISTANCE',
	LAST_SERVER_CLEANUP: 'LAST_SERVER_CLEANUP',
};

export const TICKET_PROGRESS = {
	CREATE: 'CREATE',
	LOAD: 'LOAD',
};

export const TICKET_STATUS = {
	WAITING_ON_CUSTOMER: 'Waiting on Customer',
	NEW: 'New',
	OPEN: 'Open',
	CLOSED: 'Closed',
};

export const ASSET_CATEGORIES = [
	'AutoDedicated',
	'StrictDedicated',
	'VirtualDedicated',
	'CloudSitesList',
	'CloudSitesListPlan',
	'ManagedApplication',
];

export const INITIAL_FORM_VALUES = {
	cancellation_reason: '',
	additional_info: '',
	cleanup_assets: false,
};

export type CancellationFormData = typeof INITIAL_FORM_VALUES;
